import { render } from "./SweetsAndDrinksIndex.vue?vue&type=template&id=7f005b99"
import script from "./SweetsAndDrinksIndex.vue?vue&type=script&lang=js"
export * from "./SweetsAndDrinksIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__